/**
 * Parse version number of the application client version
 */
export function appClientVersionNumberParser(clientVersion: string) {
	if (!clientVersion) {
		return null;
	}
	const versionNumberString = clientVersion.split(' ')[0];
	if (!versionNumberString) {
		return null;
	}
	const versionNumber = Number(clientVersion.split(' ')[0]);
	if (isNaN(versionNumber)) {
		return null;
	}
	return versionNumber;
}

/**
 * Parse meta parameters of the application client version used to correct and soft update the page
 * Example of the client version value: "100 jitter(60-600) inactivity-interval(1800) force-interval(43200) update-time(1623681990)"
 */
export function appClientVersionMetaParser(clientVersion: string) {
	const [, jitterMin, jitterMax] = /jitter\((\d+)-(\d+)\)/.exec(clientVersion) || [];
	const inactivityInterval = /inactivity-interval\((\d+)\)/.exec(clientVersion)?.[1];
	const maxInterval = /force-interval\((\d+)\)/.exec(clientVersion)?.[1];
	const updateTime = /update-time\((\d+)\)/.exec(clientVersion)?.[1];

	if (!jitterMin || !jitterMax || !inactivityInterval || !maxInterval || !updateTime) {
		return null;
	}

	return {
		jitterMin: Number(jitterMin) * 1000,
		jitterMax: Number(jitterMax) * 1000,
		inactivityInterval: Number(inactivityInterval) * 1000,
		maxInterval: Number(maxInterval) * 1000,
		updateTime: Number(updateTime) * 1000,
	};
}
